import { Alert, AlertDescription, AlertIcon } from "@chakra-ui/react";
import { useVVStore } from "components/store";
import { VizvCard, VizvCardContent, VizvMainCol } from "components/vizvComponents";
import { useVVNav } from "components/vvNav";
import { useLocation } from "react-router";

export function Ack() {
	const vvNav = useVVNav();
	const loc = useLocation();
	const message =
		loc.pathname.endsWith('/email-confirmed/token-not-found') ? "Nem találom a tokent. Lejárt, vagy aktiváltad már az email-címet."
			: loc.pathname.endsWith('/email-confirmed') ? "Az email cím megerősítve" // ez szerintem nem kell
				: loc.pathname.endsWith('/email-rejected') ? "Köszönjük a visszajelzést és elnézést a zavarásért!"
					: "?";



	return <VizvMainCol>
		<VizvCard onClose={vvNav.toRoot} >
			<VizvCardContent>
				<Alert status="error">
					<AlertIcon />
					<AlertDescription>
						{message}
					</AlertDescription>
				</Alert>
			</VizvCardContent>


		</VizvCard>
	</VizvMainCol>
}